import axios from 'axios'

/**
 * Before any API call, retrieve the clientID from the evnironmet to set the required X-IBM-Client-Id value
 **/
async function checkCredential(config) {
  if (!config.url.includes('apimanagerconsumercredentials')) {
    if (!window.api_credentials && !window.api_credentials_request) {
      window.api_credentials_request = axios
        .get('/portal/config/apimanagerconsumercredentials.json')
        .then(resp => (window.api_credentials = resp.data))
        .catch(err => console.log('Error fetching credentials ' + err))
    }
    await window.api_credentials_request
    config.headers.common['X-IBM-Client-Id'] = window.api_credentials?.clientId
  }

  return config
}

axios.interceptors.request.use(checkCredential)

export function flagSession() {
	window.localStorage.setItem('keepSessionFlag','true')
}
export function hasSession() {
	return !!window.localStorage.getItem('keepSessionFlag')
}
export function removeSession() {
	window.localStorage.removeItem('keepSessionFlag')
}

export async function ensureSesionRenew(lang) {
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'types', {
      params: { language: lang },
    })
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      return {
        code: 500,
      }
      // }
    })
  return response
}